import { createLegalPageLoadData } from '../legalPageAssets';

export const ASSET_NAME = 'privacy-policy';

export const loadData = createLegalPageLoadData({
  assetName: ASSET_NAME,
  stateKey: 'privacyPolicy',
});
